<template>
  <footer class="footer">
    <!-- Navigation Links -->
    <div class="footer-links">
      <a href="#" class="footer-link">About Us</a>
      <a href="#" class="footer-link">Terms & Conditions</a>
      <a href="#" class="footer-link">Privacy Policy</a>
      <a href="#" class="footer-link">FAQ</a>
    </div>

    <!-- Social Media Links -->
    <div class="social-media">
      <a href="#" aria-label="Instagram">
        <font-awesome-icon :icon="['fab', 'instagram']" />
      </a>
      <a href="#" aria-label="Facebook">
        <font-awesome-icon :icon="['fab', 'facebook']" />
      </a>
      <a href="#" aria-label="Twitter">
        <font-awesome-icon :icon="['fab', 'twitter']" />
      </a>
    </div>

    <!-- Contact Information -->
    <div class="contact-info">
      <p>Contact: 123-456-7890 | info@bigbananaarm.com</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
.footer {
  background-color: #333;
  color: white;
  padding: 20px;
  text-align: center;
}

.footer-links {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 15px;
}

.footer-link {
  color: white;
  text-decoration: none;
  font-weight: bold;
}

.footer-link:hover {
  text-decoration: underline;
}

.social-media {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-bottom: 15px;
}

.social-media a {
  font-size: 24px;
  color: white;
}

.social-media a:hover {
  color: crimson;
}

.contact-info {
  font-size: 0.9em;
  color: #ccc;
}
</style>
